import { t } from 'i18next'

export const formatBool = (val: boolean | undefined | null, trueTranslation = t('common:yes')) => {
  if (typeof val === 'boolean') {
    return val ? trueTranslation : t('common:no')
  }
  return t('common:unknown')
}
